namespace TabAurous.Master {
    export interface EmployeeMasterRow {
        EmployeeId?: number;
        DesignationId?: number;
        EmployeeName?: string;
        EmployeeCode?: string;
        EmploymentType?: number;
        DepartmentId?: number;
        ManagerId?: number;
        ReportToId?: number;
        Dob?: string;
        MaritalStatus?: Common.MartialStatus;
        Gender?: Common.GenderType;
        Qualification?: number;
        Address?: string;
        PhoneNumber?: string;
        MobileNumber?: string;
        Email?: string;
        JoiningDate?: string;
        TerminationDate?: string;
        IsDisabled?: boolean;
        Narration?: string;
        BloodGroup?: Common.BloodGroups;
        PassportNo?: string;
        PassportExpiryDate?: string;
        LabourCardNumber?: string;
        LabourCardExpiryDate?: string;
        VisaNumber?: string;
        VisaExpiryDate?: string;
        SalaryType?: Common.SalaryType;
        DailyWage?: number;
        GrossSalary?: number;
        BankName?: string;
        BranchName?: string;
        BankAccountNumber?: string;
        BranchCode?: string;
        BankIfsc?: string;
        PanNumber?: string;
        PfNumber?: string;
        EsiNumber?: string;
        ExtraDate?: string;
        Extra1?: string;
        Extra2?: string;
        SalaryPackageId?: number;
        LeavePolicyId?: number;
        CompanyId?: number;
        DesignationName?: string;
        CompanyName?: string;
        Departments?: number[];
    }

    export namespace EmployeeMasterRow {
        export const idProperty = 'EmployeeId';
        export const nameProperty = 'EmployeeName';
        export const localTextPrefix = 'Master.EmployeeMaster';
        export const lookupKey = 'Master.EmployeeMaster';

        export function getLookup(): Q.Lookup<EmployeeMasterRow> {
            return Q.getLookup<EmployeeMasterRow>('Master.EmployeeMaster');
        }
        export const deletePermission = 'HR:Employee:Delete';
        export const insertPermission = 'HR:Employee:Add';
        export const readPermission = '*';
        export const updatePermission = 'HR:Employee:Edit';

        export declare const enum Fields {
            EmployeeId = "EmployeeId",
            DesignationId = "DesignationId",
            EmployeeName = "EmployeeName",
            EmployeeCode = "EmployeeCode",
            EmploymentType = "EmploymentType",
            DepartmentId = "DepartmentId",
            ManagerId = "ManagerId",
            ReportToId = "ReportToId",
            Dob = "Dob",
            MaritalStatus = "MaritalStatus",
            Gender = "Gender",
            Qualification = "Qualification",
            Address = "Address",
            PhoneNumber = "PhoneNumber",
            MobileNumber = "MobileNumber",
            Email = "Email",
            JoiningDate = "JoiningDate",
            TerminationDate = "TerminationDate",
            IsDisabled = "IsDisabled",
            Narration = "Narration",
            BloodGroup = "BloodGroup",
            PassportNo = "PassportNo",
            PassportExpiryDate = "PassportExpiryDate",
            LabourCardNumber = "LabourCardNumber",
            LabourCardExpiryDate = "LabourCardExpiryDate",
            VisaNumber = "VisaNumber",
            VisaExpiryDate = "VisaExpiryDate",
            SalaryType = "SalaryType",
            DailyWage = "DailyWage",
            GrossSalary = "GrossSalary",
            BankName = "BankName",
            BranchName = "BranchName",
            BankAccountNumber = "BankAccountNumber",
            BranchCode = "BranchCode",
            BankIfsc = "BankIfsc",
            PanNumber = "PanNumber",
            PfNumber = "PfNumber",
            EsiNumber = "EsiNumber",
            ExtraDate = "ExtraDate",
            Extra1 = "Extra1",
            Extra2 = "Extra2",
            SalaryPackageId = "SalaryPackageId",
            LeavePolicyId = "LeavePolicyId",
            CompanyId = "CompanyId",
            DesignationName = "DesignationName",
            CompanyName = "CompanyName",
            Departments = "Departments"
        }
    }
}
